import React, { useState } from "react";
import { Button, Modal, Upload, message, Radio } from "antd";

import { UploadOutlined } from "@ant-design/icons";

function CertificateAddModal({
  certificateModalOpen,
  setCertificateModalOpen,
  companyName,
  email,
}) {
  const [documentType, setDocumentType] = useState({
    documenttype: "",
  });
  const baseURL = "http://localhost:4200";

  const props = {
    name: "companydoc",
    action: `${baseURL}/updateCompanyDocuments/${companyName}/${email}`,
    maxCount: 1,

    data: {
      documenttype: "pdf",
      documentname: documentType,
    },
    onChange(info) {
      console.log(info, "This is info");
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        //now check if
        // 1. Resume already exists for this JD by the same user ID
        // 2. Resume already exists for this JD byt other user ID
        // 3. Resume already exist for this JD
        //response: '{"status": "success"}', // response from server
        var responseData = info.file.response;
        if (responseData.status == "DUPLICATE_UPLOADED_VENDOR") {
          message.success(
            `${info.file.name} Duplicate, Uploaded by Another Vendor`
          );
        } else if (responseData.status == "DUPLICATE_UPLOADED_INTERNAL") {
          message.success(
            `${info.file.name} Duplicate, Already Assigned to this JD`
          );
        } else {
          message.success(`${info.file.name} file uploaded successfully`);
        }
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  const handleChange = (e) => {
    setDocumentType({
      documenttype: e.target.value,
    });
  };

  return (
    <Modal
      title="Upload Certificate"
      open={certificateModalOpen}
      footer={null}
      onCancel={() => setCertificateModalOpen(false)}
    >
      <Radio.Group
        className="profile-radio-wrapper"
        onChange={handleChange}
        name="documenttype"
        style={{ marginTop: "20px", marginBottom: "30px" }}
      >
        <Radio className="radio-option" value="registration-doc">
          Registration Certificates
        </Radio>
        <Radio className="radio-option" value="tax-certificate">
          GST/TAX Certificates
        </Radio>
      </Radio.Group>

      <Upload {...props}>
        <Button icon={<UploadOutlined />}>Click to Upload</Button>
      </Upload>
    </Modal>
  );
}

export default CertificateAddModal;
